export const initService = <T extends object>(getService: () => T) => {
  return Object.freeze(getService());
};
